import React from 'react';
import Moment from "react-moment";
import { Typography } from "@material-ui/core";
import { Grid, Button, Chip } from "@material-ui/core";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import { makeStyles } from "@material-ui/styles";
import MediaQuery from "react-responsive";

import ApproveRejectModal from '../../../Admin/Components/ApproveRejectModal';
import StarWidgetReadOnly from "Components/StarWidgetReadOnly";

import { verifyReview, rejectReview } from 'db';

const useStyles = makeStyles((theme) => ({
    formControl: {
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
    },
    "@media (max-width: 700px)": {
      formControl: {
        paddingLeft: theme.spacing(1),
        paddingRight: theme.spacing(1),
      },
    },
  }));

export default function Review({review, admin, onAdminAction}) {
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  const classes = useStyles();

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  const handleReject = () => {
    rejectReview(review)
    onAdminAction();
    setIsModalOpen(false);
  }
  const handleApprove = () => {
    verifyReview(review);
    onAdminAction();
    setIsModalOpen(false);
  }
    
  const {
      companyName,
      department,
      reviewTitle = "Title Goes Here",
      impact,
      location,
      nomad,
      overlap,
      remoteTestimony,
      submissionDate,
      rating,
      verified,
      deleted
    } = review;

    let locationString =
      location && location.description ? location.description : null;

    let notVerifiedText = verified ? '' : ' - Not Verified';
    const adminStyle = admin ? { borderTop: "1px solid black", paddingTop: "10px" } : null 
    
    return (
        <Grid
            className={classes.formControl}
            style={{ marginBottom: "25px", ...adminStyle }}
        >
            <ApproveRejectModal 
              isOpen={isModalOpen} 
              handleClose={closeModal} 
              handleReject={handleReject}
              handleApprove={handleApprove}
            />
            <Grid
              container
              justify="space-between"
              direction="row"
              xs={12}
              style={{ marginTop: "25px", marginBottom: "15px" }}
            >
              { admin ? (<Button variant="outlined" style={{ cursor: "pointer" }} onClick={openModal}>Approve/Deny</Button>) : null}
            </Grid>            

            <Grid
            container
            alignItems="center"
            direction="row"
            xs={12}
            style={{ marginTop: "25px", marginBottom: "15px" }}
            >
            <Grid container xs={10}>
                <Typography variant={"h6"} style={{ fontWeight: "bold" }}>
                {`"${reviewTitle}${notVerifiedText}"`}
                </Typography>
                <Grid item direction="row" xs={12}>
                <StarWidgetReadOnly rating={rating} />
                <DepartmentHeader
                    department={department}
                    companyName={companyName}
                    style={{
                    marginLeft: "20px",
                    color: "gray",
                    fontSize: "14px",
                    }}
                />
                </Grid>
            </Grid>
            <MediaQuery maxWidth={700}>
                <Grid
                container
                justify="flex-start"
                style={{ marginTop: "13px" }}
                >
                <FlexibleHours
                    overlap={overlap}
                    style={{ marginRight: "10px" }}
                />
                <Impact
                    isHighImpact={impact}
                    style={{ marginRight: "10px" }}
                />
                <DigitalNomadChip isNomad={nomad} />
                </Grid>
            </MediaQuery>
            <MediaQuery minWidth={701}>
                <Grid container xs={2} justify="flex-end">
                <ReviewDate date={submissionDate.toDate()} />
                </Grid>
            </MediaQuery>
            </Grid>
            <Grid
            style={{ padding: "15px 0", marginLeft: "5px", color: "#404040" }}
            >
            <Typography style={{ textAlign: "left" }}>
                {remoteTestimony}
            </Typography>
            </Grid>
            <MediaQuery maxWidth={700}>
            <Grid
                container
                direction="row"
                justify="space-between"
                style={{ paddingTop: "20px" }}
            >
                <Location location={locationString} />
                <ReviewDate date={submissionDate.toDate()} />
            </Grid>
            </MediaQuery>
            <MediaQuery minWidth={701}>
            <Grid
                container
                direction="row"
                justify="space-between"
                style={{ paddingTop: "20px" }}
            >
                <Location location={locationString} />
                <Grid item>
                <FlexibleHours
                    overlap={overlap}
                    style={{ marginLeft: "15px" }}
                />
                <Impact
                    isHighImpact={impact}
                    style={{ marginLeft: "15px" }}
                />
                <DigitalNomadChip
                    isNomad={nomad}
                    style={{ marginLeft: "15px" }}
                />
                </Grid>
            </Grid>
            </MediaQuery>
            <hr style={{ marginTop: "10px" }} />
        </Grid>
    );
  }

function DepartmentHeader({ department, companyName, style }) {
    if (!department) {
      return null;
    }
  
    return (
      <Typography style={{ display: "inline", ...style }}>
        {`${department} at ${companyName}`}
      </Typography>
    );
}


function FlexibleHours({ overlap, style }) {
    if (overlap !== "noOverlap") return null;

    return (
        <Chip
        label="Flexible Hours"
        variant="outlined"
        color="primary"
        size="small"
        style={style}
        />
    );
}
  
function DigitalNomadChip({ isNomad, style }) {
    if (!isNomad) return null;
  
    return (
      <Chip
        label="Digital Nomad"
        variant="outlined"
        color="primary"
        size="small"
        style={style}
      />
    );
}
  
function Impact({ isHighImpact, style }) {
    if (!isHighImpact) return null;

    return (
        <Chip
        label="High Impact"
        variant="outlined"
        color="primary"
        size="small"
        style={style}
        />
    );
}  

function Location({ location }) {
    return (
      <Typography style={{ fontSize: "14px" }}>
        <LocationOnIcon
          style={{ marginBottom: "-4px", color: "#404040", fontSize: "20px" }}
        />{" "}
        {location}
      </Typography>
    );
  }
  
  function ReviewDate({ date }) {
    return (
      <Typography style={{ color: "#7f7f7f", fontSize: "16px" }}>
        <Moment format="MMMM DD, YYYY">{date}</Moment>
      </Typography>
    );
  }